import { faEye, faSave, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '@material-ui/core/IconButton';
import { PDFDownloadLink } from '@react-pdf/renderer';
import cogoToast from 'cogo-toast';
import React, { useContext, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import CurrencyInput from 'react-currency-input-field';
import {
    Button,
    Card,
    CardBody,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import ButtonIcon from '../../../components/common/ButtonIcon';
import FalconCardHeader from '../../../components/common/FalconCardHeader';
import ThemeBackground from '../../../components/common/ThemeBackground';
import { urlApi } from '../../../configuracion/serverConfig';
import { CREDIT_MODE_ID } from '../../../data/constans';
import { authSesion, headers } from "../../../helpers/authSesion";
import { formatterId } from '../../../helpers/formatters';
import numToWord from '../../../helpers/numToWord';
import { currencyFormat, idFormat, refFormat } from '../../../helpers/tableFormatters';
import RecaudoInvoice from '../../recaudar/invoice/RecaudoInvoice';
import { StateContext } from '../StateContext';
import ModalCredits from '../children/CreditSelectModal';

const CreditInfo = () => {
    let sesion = JSON.parse(sessionStorage.getItem('Usuario'));
    const context = useContext(StateContext);
    const { creditSelected: selected, handleRefinance, handleRefreshPrestamo } = context;
    const [showThirdModal, setShowThirdModal] = useState();
    const [thirdCredits, setThirdCredits] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [ownProps, setOwnProps] = useState();
    const [showModalDescuento, setShowModalDescuento] = useState(false);
    const [descuento, setDescuento] = useState(0);

    const handleSelectCreditModal = () => {
        setThirdCredits(selected.prestamos)
        setShowThirdModal(true);
    }

    const closeModal = () => {
        setShowThirdModal(false)
        setThirdCredits(selected.prestamos)
    }

    const toggleModal = () => {
        setShowModal(false);
    }

    const guardaDescuento = () => {
        if (document.styleSheets[0].cssRules[0].selectorText != ".react-confirm-alert-overlay") {
            document.styleSheets[0].insertRule('.react-confirm-alert-overlay { z-index: 9999 !important; }', 0);
        }
        var monto = descuento;
        if (!monto || monto < 0) {
            cogoToast.error("Diligincie un monto de descuento válido", { position: 'bottom-right' });
            return;
        }
        if (monto > selected.pagos[0].saldoProyectado) {
            cogoToast.error("El descuento no puede ser mayor al saldo", { position: 'bottom-right' });
            return;
        }
        confirmAlert({
            title: 'Agregar descuento',
            message: '¿Confirma agregar un descuento por ' + monto + '?',
            buttons: [{
                label: 'Sí',
                onClick: () => {
                    fetch(urlApi + '/descuento', {
                        method: 'POST',
                        headers,
                        body: JSON.stringify({
                            monto: monto,
                            prestamo: selected.prestamo,
                            sesion: authSesion()
                        })
                    }).then(data => {
                        cogoToast.info("Se agregó el descuento satisfactoriamente", { position: 'bottom-right' });
                        setShowModalDescuento(false);
                        handleRefreshPrestamo();
                    }).catch(err => {
                        console.log('err', err);
                        cogoToast.error(err);
                    });
                }
            }, {
                label: 'No'
            }]
        });
    }

    const generaRecibo = () => {
        setOwnProps({
            client: selected.nomCliente,
            clientTypeId: selected.tipoIdCliente,
            clientId: formatterId(Number(selected.idCliente)),
            serial: "CE-" + selected.serial,
            ciudad: 'MAICAO - LA GUAJIRA',
            idCredit: selected.idCredito,
            amount: currencyFormat(selected.desembolso),
            concept: selected.tesoreria,
            sumWord: numToWord(selected.desembolso),
            checkCash: true,
            checkWireTransfer: false,
            checkPSE: false,
            checkCheque: selected.modalidad == 3,
            date: selected.fechaDesembolso.split('-'),
            observations: selected.observacion,
            terceroAutorizado: selected.autorizado
        });
        setShowModal(true);
    };

    return (
        <>
            <Modal isOpen={showModalDescuento} size="md" toggle={() => setShowModalDescuento(false)}>
                <ModalHeader>Agregar descuento comercial</ModalHeader>
                <ModalBody>
                    <table cellPadding={10}>
                        <tr>
                            <td>Monto</td>
                            <td>
                                <CurrencyInput
                                    className="form-control pl-2"
                                    allowNegativeValue={false}
                                    prefix='$'
                                    intlConfig={{ locale: 'es-CO', currency: 'COP' }}
                                    onValueChange={value => setDescuento(value)}
                                    decimalScale={0}
                                    maxLength={20}
                                    placeholder="$ 0"
                                />
                            </td>
                        </tr>
                    </table>
                </ModalBody>
                <ModalFooter className="no-border">
                    <div className="row col-md-12">
                        <div className="col-md-10 text-right">
                            <Button className="mr-1" color="primary" size="sm" outline style={{ 'height': '36px' }} onClick={guardaDescuento}>
                                <i className="mr-1">
                                    {' '}
                                    <FontAwesomeIcon icon={faSave} />
                                </i>
                                Guardar
                            </Button>
                            &nbsp; &nbsp;
                            <Button className="mr-1" color="primary" size="sm" outline style={{ 'height': '36px' }} onClick={() => setShowModalDescuento(false)}>
                                <i className="mr-1">
                                    {' '}
                                    <FontAwesomeIcon icon={faUndo} />
                                </i>
                                Cancelar
                            </Button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showModal} size="md" toggle={() => toggleModal()}>
                {ownProps && (
                    <ButtonIcon color="falcon-default" size="sm" icon="arrow-down" className="mr-2 mb-2 mb-sm-0 p-1 border-none shadow-none">
                        <PDFDownloadLink document={<RecaudoInvoice title="Comprobante Egreso" data={ownProps} egreso />} fileName={`comprobante_egreso_${selected.idCredito}.pdf`} >
                            {({ loading }) =>
                                loading ? 'Cargando comprobante...' : 'Descargar comprobante egreso'
                            }
                        </PDFDownloadLink>
                    </ButtonIcon>)}
            </Modal>
            <ModalCredits open={showThirdModal} title="Refinanciación" data={thirdCredits} toggle={closeModal} />
            <Card className="my-3" >
                <ThemeBackground color='info' />
                <FalconCardHeader title="Información del Crédito">
                    {sesion.perfil == 1 && selected && selected.estado == 2 && [
                        <ButtonIcon onClick={handleRefinance} color="falcon-primary" size="sm">
                            Refinanciar
                        </ButtonIcon>,
                        <ButtonIcon onClick={() => setShowModalDescuento(true)} color="falcon-primary" size="sm" style={{ marginLeft: '5px' }}>
                            Descuento comercial
                        </ButtonIcon>
                    ]}
                </FalconCardHeader>
                <CardBody className="border-top px-4">
                    {selected && ([
                        <Row>
                            <Col lg={4} xs={4}>
                                <DetailRow title="Nro. de Credito">{selected.idCredito || <span className='p-2'></span>}</DetailRow>
                                <DetailRow title="Línea de Crédito">{selected.nomLinea || <span className='p-2'></span>}</DetailRow>
                                <DetailRow title="Modalidad de Crédito">{selected.nomModalidad || <span className='p-2'></span>}</DetailRow>
                                <DetailRow title="Identificación">
                                    {selected.tipoIdCliente} {idFormat(selected.idCliente)}
                                </DetailRow>
                            </Col>

                            <Col lg={4} xs={4}>
                                <DetailRow title="Fecha Solicitud">{selected.fechaSolicitud || <span className='p-2'></span>}</DetailRow>
                                <DetailRow title="Sublínea de Crédito">{selected.nomSubLinea || <span className='p-2'></span>}</DetailRow>

                                {[CREDIT_MODE_ID.UPDATE].includes(`${selected.idModalidad}`) && (
                                    <DetailRow title="Monto Actualización">{selected.valorActualizacion ? currencyFormat(selected.valorActualizacion) : <span className='p-2'></span>}</DetailRow>
                                )}
                                {[CREDIT_MODE_ID.UNIFICATION].includes(`${selected.idModalidad}`) && (
                                    <DetailRow title="Monto Unificación">{selected.valorUnificacion ? currencyFormat(selected.valorUnificacion) : <span className='p-2'></span>}</DetailRow>
                                )}

                                <DetailRow title="Razón Social o Nombre del Cliente" childrenClasses="text-uppercase">{selected.nomCliente || <span className='p-2'></span>}</DetailRow>

                                {[CREDIT_MODE_ID.REFINANCE].includes(`${selected.idModalidad}`) ? (
                                    <DetailRow title="-">
                                        <a className="font-weight-semi-bold fs--1 text-nowrap cursor-pointer" onClick={() => handleSelectCreditModal(true)}>
                                            {/* {liquidacion
                    && [CREDIT_MODE_ID.UPDATE].includes(`${selected.idModalidad }`)
                      && "Ver Créditos Actualizados"}
                  {liquidacion
                    && [CREDIT_MODE_ID.UNIFICATION].includes(`${selected.idModalidad }`)
                      && "Ver Créditos Unificados"} */}
                                            {[CREDIT_MODE_ID.REFINANCE].includes(`${selected.idModalidad}`)
                                                && "Ver crédito Refinanciado"}
                                            <FontAwesomeIcon icon="angle-right" transform="down-1.5" className="ml-1" />
                                        </a>
                                    </DetailRow>
                                ) : <></>}

                            </Col>

                            <Col lg={4} xs={4} className="text-right">
                                <DetailRow title="Fecha de Desembolso">
                                    {selected.fechaDesembolso || <span className='p-2'></span>}
                                    {selected.serial && selected.desembolso && <IconButton onClick={() => generaRecibo()} style={{ width: '30px', height: 'auto' }}>
                                        <FontAwesomeIcon style={{ width: '16px' }} icon={faEye} color="SteelBlue" />
                                    </IconButton> || ""}
                                </DetailRow>
                                <DetailRow title="Pagaduría">{selected.nomPagaduria || <span className='p-2'></span>}</DetailRow>
                                <DetailRow title="Saldo Actual">{currencyFormat(selected.pagos[0].saldoFinal)}</DetailRow>
                                <DetailRow title="Fecha Vencimiento">{selected.fechaVencimiento || <span className='p-2'></span>}</DetailRow>
                            </Col>

                        </Row>,
                        <Row>
                            <Col lg={4} xs={4}>
                                <DetailRow title="Nro. Solicitud">
                                    {selected.idSolicitud && refFormat(selected.idSolicitud) || <span className='p-2'></span>}
                                </DetailRow>
                            </Col>
                            <Col lg={6} xs={6}>
                                <DetailRow title="Anotaciones">
                                    {selected.anotacion || <span className='p-2'></span>}
                                </DetailRow>
                            </Col>
                            <Col lg={2} xs={2}>
                                <ButtonIcon onClick={handleRefreshPrestamo} color="falcon-primary" size="sm">
                                    Refrescar
                                </ButtonIcon>
                            </Col>
                        </Row>
                    ])}
                </CardBody>
            </Card>
        </>
    );
};

export default CreditInfo;
